import formatBytes from 'bytes';
import { formatDistanceToNowStrict } from 'date-fns';

import { http } from '@/services/http';

interface FilesResponse {
  totalSize: number;
  items: {
    fileName: string;
    fileType: string;
    groupName: string;
    fid: string;
    latest: boolean;
    size: number;
    arrivalTime: string;
    fields?: {
      createdAt?: string;
    };
  }[];
}

export interface WidgetFile {
  name: string;
  size: string;
  created: string;
  fid: string;
}

const parseFiles = (data: FilesResponse): WidgetFile[] =>
  data.items.map(item => ({
    name: item.fileName,
    size: formatBytes(item.size, { unitSeparator: ' ' }) ?? '-',
    created: formatDistanceToNowStrict(new Date(item.fields?.createdAt ?? item.arrivalTime), {
      addSuffix: true
    }),
    fid: item.fid
  }));

export const filesWidgetApi = {
  getFiles: async (groupName: string, size?: number): Promise<WidgetFile[]> => {
    const sizeParam = size ? `&size=${size}` : '';
    const url = `/proxy/datalake/search?fileName=*&groupName=${encodeURIComponent(groupName)}${sizeParam}`;
    const response = await http.internal.get(url);
    return parseFiles(response.data);
  }
};
